<div><p class="m-tx2"><a class="link inv" @click="openModal">Set up Donut in a private Slack channel</a></p></div>